export { default as getTelemetryEarliest } from './getTelemetryEarliest';
export { default as getTelemetryHistory } from './getTelemetryHistory';
export { default as getTelemetryLatest } from './getTelemetryLatest';
export { default as getTelemetryState } from './getTelemetryState';

export function getValidTelemetryProperties(listableProperties, propertyArray) {
  const nonPropertyProperties = ['$x', '$y', 'icon'];

  const valid = propertyArray.filter((p) => {
    if (nonPropertyProperties.includes(p)) return true;
    return listableProperties.filter(({ name }) => name === p).length;
  });

  if (valid.length === 0) {
    return ['$id'];
  }
  return valid;
}
